/** @jsx jsx */
import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';

export const containerPaddingCss = css({
  padding: '56px 0 64px 0',
  [MediaQueries.mdAndUp]: {
    padding: '80px 0 88px 0',
  },
  [MediaQueries.lgAndUp]: {
    padding: '128px 0 136px 0',
  },
});

export const descriptionCss = css(typography.effra18, {
  color: colorsPalette.grey80,
  marginBottom: 32,
});

export const headlineCss = css(typography.effra40, {
  fontWeight: fontWeights.medium,
  color: colorsPalette.black,
  marginBottom: 24,
});
